export default {
  basic: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "basicSummarySaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "basicSummaryCurrentOdds"
    }
  ],
  advanced: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "advancedSummarySaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "advancedSummaryCurrentOdds"
    },
    {
      title: "Age",
      sortData: "(Youngest > Oldest)",
      key: "age",
      qaLabel: "advancedSummaryAge"
    },
    {
      title: "Medication",
      sortData: "(Yes > No)",
      key: "med",
      qaLabel: "advancedSummaryMedication"
    },
    {
      title: "Weight",
      sortData: "(Heaviest > Lightest)",
      key: "weight",
      qaLabel: "advancedSummaryWeight"
    }
  ],
  snapshot: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "snapshotSaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "snapshotCurrentOdds"
    },
    {
      title: "Power Rating",
      sortData: "(High > Low)",
      key: "power",
      qaLabel: "snapshotPowerRating"
    },
    {
      title: "Win Rate",
      sortData: "(High > Low)",
      key: "winStarts",
      qaLabel: "snapshotNumberOfWins"
    },
    {
      title: "Days Rest",
      sortData: "(Shortest > Longest)",
      key: "daysOff",
      qaLabel: "snapshotDaysRest"
    }
  ],
  speed: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "speedSaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "speedCurrentOdds"
    },
    {
      title: "Average Speed",
      sortData: "(High > Low)",
      key: "avgSpeed",
      qaLabel: "speedAverageSpeed"
    },
    {
      title: "Average Distance",
      sortData: "(High > Low)",
      key: "avgDistance",
      qaLabel: "speedAverageDistance"
    },
    {
      title: "High Speed",
      sortData: "(High > Low)",
      key: "highSpeed",
      qaLabel: "speedHighSpeed"
    },
    {
      title: "Average Class",
      sortData: "(High > Low)",
      key: "avgClassRating",
      qaLabel: "speedAverageClass"
    },
    {
      title: "Last Class",
      sortData: "(High > Low)",
      key: "lastClassRating",
      qaLabel: "speedLastClass"
    }
  ],
  pace: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "paceSaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "paceCurrentOdds"
    },
    {
      title: "Number of Races",
      sortData: "(Highest > Lowest)",
      key: "numRaces",
      qaLabel: "paceNumberOfRaces"
    },
    {
      title: "Early Speed",
      sortData: "(High > Low)",
      key: "early",
      qaLabel: "paceEarlySpeed"
    },
    {
      title: "Middle Speed",
      sortData: "(High > Low)",
      key: "middle",
      qaLabel: "paceMiddleSpeed"
    },
    {
      title: "Finish Speed",
      sortData: "(High > Low)",
      key: "finish",
      qaLabel: "paceFinishSpeed"
    }
  ],
  stats: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "statsSaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "statsCurrentOdds"
    },
    {
      title: "Number of Runs",
      sortData: "(Most > Fewest)",
      key: "starts",
      qaLabel: "statsNumberOfRuns"
    },
    {
      title: "1st Place Finishes",
      sortData: "(Most > Fewest)",
      key: "wins",
      qaLabel: "stats1stPlaceFinishes"
    },
    {
      title: "2nd Place Finishes",
      sortData: "(Most > Fewest)",
      key: "places",
      qaLabel: "stats2ndPlaceFinishes"
    },
    {
      title: "3rd Place Finishes",
      sortData: "(Most > Fewest)",
      key: "shows",
      qaLabel: "stats3rdPlaceFinishes"
    }
  ]
};

export const handicappingSortGreyhoundOptions = {
  basic: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "basicSummarySaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "basicSummaryCurrentOdds"
    }
  ],
  advanced: [
    {
      title: "Saddlecloth number",
      sortData: "(Low > High)",
      key: "saddlecloth",
      qaLabel: "advancedSummarySaddlecloth"
    },
    {
      title: "Current Odds",
      sortData: "(Shortest > Longest)",
      key: "odds",
      qaLabel: "advancedSummaryCurrentOdds"
    }
  ],
  snapshot: [],
  pace: [],
  speed: [],
  stats: []
};
